/**
 * `base`, or while `taken` holds it, `base` with a numeric suffix in place of
 * its last characters, never longer than five. Compares and records
 * trimmed, lower-cased.
 */ export function claimAbbreviation(base, taken) {
    const key = (abbreviation)=>abbreviation.trim().toLowerCase();
    let claimed = base;
    for(let suffix = 2; taken.has(key(claimed)); suffix++){
        const digits = String(suffix);
        claimed = base.slice(0, 5 - digits.length) + digits;
    }
    taken.add(key(claimed));
    return claimed;
}
/**
 * Upper-case initials of the name's words, two to five characters (a
 * one-word name takes its first two letters): the base `claimAbbreviation`
 * claims for a department the data source names.
 */ export function abbreviationInitials(name) {
    const words = name.split(/[^\p{L}\p{N}]+/u).filter(Boolean);
    const initials = words.map((word)=>word[0]).join('');
    const letters = initials.length >= 2 ? initials : words.join('').slice(0, 2);
    return letters.slice(0, 5).toUpperCase().padEnd(2, 'X');
}

//# sourceMappingURL=claim-abbreviation.js.map